<div class="ir-plugin th-plugin" *ngIf="plugin">
  <div class="ir-line ir-plugin-title" [ngClass]="{ 'ir-plugin-gray': showBreadcrumbs }">
    <div class="ir-line--right">
      <div
        class="ir-btn"
        *ngIf="showHelpButton"
        [ngClass]="showPluginHelp ? 'th-btn-action' : 'th-btn-normal'"
        (click)="showHidePluginHelp()"
      >
        <span>?</span>
      </div>
      <div
        class="ir-btn"
        [ngClass]="showValidations ? 'th-btn-action' : 'th-btn-normal'"
        [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
        [routerLink]="getEditRoute()"
      >
        <span>{{ (showValidations ? 'common.open' : 'common.edit') | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
      <span>
        {{ showBreadcrumbs ? plugin.inspection.name + ' / ' : '' }}
        {{ showBreadcrumbs && plugin.point?.name ? plugin.point?.name + ' / ' : '' }}
        {{ 'plugins.comment.name' | translate }}</span
      ><!--<strong>- AX87</strong>-->
    </div>
  </div>
  <preview-validation-messages [showValidations]="showValidations" [messages]="messages"></preview-validation-messages>
  <div class="ir-plugin-content" *ngIf="showContent">
    <p class="ir-plugin-instruction" *ngIf="showPluginHelp">
      <span innerHtml="{{ plugin?.description }}"></span>
    </p>
    <div *ngFor="let item of remarks">
      <div class="ir-plugin-values th-plugin-values" *ngIf="item && item.Comment">
        <p>
          <span *ngIf="item.Icon">
            <i class="material-icons">{{ item.Icon | icon }}</i>
          </span>
        </p>
        <p *ngIf="item.Type != -1">
          <span
            >{{ 'plugins.comment.to' | translate }}<strong> {{ item.Type | commenttype }}</strong></span
          >
        </p>
        <p class="ir-pv3">
          <span innerHtml="{{ item.Comment }}"></span>
        </p>
      </div>
    </div>
  </div>
</div>
